import { useEffect } from 'react';
export function useKeyDown(callbacks) {
    useEffect(function () {
        if (Object.keys(callbacks).length === 0) {
            return;
        }
        function handleKeyDown(e) {
            if (callbacks.hasOwnProperty(e.key)) {
                callbacks[e.key](e);
            }
        }
        window.addEventListener('keydown', handleKeyDown);
        return function () { return window.removeEventListener('keydown', handleKeyDown); };
    }, [callbacks]);
}
//# sourceMappingURL=useKeyDown.js.map